import React from 'react';
import {
  CheckCircleIcon,
  ExclamationIcon,
  InformationCircleIcon,
} from '@heroicons/react/outline';

export const getIcon = (type) => {
  switch (type) {
    case 'info':
      return <InformationCircleIcon className="w-5 h-5 text-info" />;
    case 'warning':
      return <ExclamationIcon className="w-5 h-5 text-warning" />;
    case 'success':
      return <CheckCircleIcon className="w-5 h-5 text-success" />;
    default:
      return null;
  }
};
